// 用前置字符捕获组保留十六进制边界校验，避免依赖旧浏览器不支持的正则后行断言。
const UUID_PATTERN = /(?:^|[^0-9a-f])([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?![0-9a-f])/i;

/** 从纯 UUID 或包含 UUID 的链接、文本中提取首个标准 UUID。 */
export function extractItineraryUuid(value: string): string | undefined {
  return value.match(UUID_PATTERN)?.[1]?.toLowerCase();
}
